// import React, { useState, useEffect, useRef } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import JoditEditor from "jodit-react";
// import { getBlogListServ, addBlogServ } from "../../services/blog.service";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";

// function AddBlog() {
//   const navigate = useNavigate();
//   const editor = useRef(null);

//   const config = {
//     placeholder: "Start typing...",
//     height: "300px",
//   };

//   const [loader, setLoader] = useState(false);

//   const [formData, setFormData] = useState({
//     image: "",
//     title: "",
//     seoTitle: "",
//     metaKeyword: "",
//     metaDescription: "",
//     rank: "",
//     tags: "",
//     specialAppereance: "",
//   });

//   const [shortDescription, setShortDescription] = useState("");
//   const [description, setDescription] = useState("");

//   const handleSubmit = async () => {
//     setLoader(true);
//     try {
//       let finalPayload = {
//         ...formData,
//         shortDescription: shortDescription,
//         description: description,
//       };
//       let response = await addBlogServ(finalPayload);
//       if (response?.data?.statusCode == "200") {
//         toast.success("Blog saved successfully!");
//         navigate("/blogs-list");
//       }
//     } catch (error) {
//       toast.error("Internal Server Error");
//     }
//     setLoader(false);
//   };

//   const isFormValid =
//     formData.title &&
//     formData.rank &&
//     formData.tags.length > 0 &&
//     shortDescription;

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Blog Management" selectedItem="Add Blog" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           ></div>

//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <div className="d-flex">
//                   <h4
//                     className="p-2 text-dark shadow rounded mb-4 "
//                     style={{ background: "#05E2B5" }}
//                   >
//                     Add Blog
//                   </h4>
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-12 mb-3">
//                   <label>Banner*</label>
//                   <div>
//                     <img
//                       src={formData?.imgPrev}
//                       style={{ height: "200px" }}
//                       className="img-fluid w-100 shadow rounded mb-2"
//                     />
//                   </div>
//                   <input
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         image: e.target.files[0],
//                         imgPrev: URL.createObjectURL(e.target.files[0]),
//                       })
//                     }
//                     className="form-control"
//                     type="file"
//                   />
//                 </div>
//                 <div className="col-6 mb-3">
//                   <label>Title*</label>
//                   <input
//                     value={formData.title}
//                     onChange={(e) =>
//                       setFormData({ ...formData, title: e.target.value })
//                     }
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="col-6 mb-3">
//                   <label>SEO Title*</label>
//                   <input
//                     value={formData.seoTitle}
//                     onChange={(e) =>
//                       setFormData({ ...formData, seoTitle: e.target.value })
//                     }
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="col-4 mb-3">
//                   <label>Meta Keyword* (Seperate by coma)</label>
//                   <input
//                     value={formData.metaKeyword}
//                     onChange={(e) =>
//                       setFormData({ ...formData, metaKeyword: e.target.value })
//                     }
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="col-4 mb-3">
//                   <label>Rank*</label>
//                   <input
//                     type="number"
//                     value={formData.rank}
//                     onChange={(e) =>
//                       setFormData({ ...formData, rank: e.target.value })
//                     }
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="col-6 mb-3">
//                   <label>Special Apereance</label>
//                   <select
//                     value={formData.specialAppereance}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         specialAppereance: e.target.value,
//                       })
//                     }
//                     className="form-control"
//                   >
//                     <option value="">Select</option>
//                     <option value="Home">Home</option>
//                   </select>
//                 </div> 

//                 <div className="col-4 mb-3">
//                   <label>Tags (seperate by coma)</label>
//                   <input
//                     value={formData.tags}
//                     onChange={(e) =>
//                       setFormData({ ...formData, tags: e.target.value })
//                     }
//                     className="form-control"
//                   />
//                 </div>

//                 <div className="col-12 mb-3">
//                   <label>Meta Description*</label>
//                   <textarea
//                     value={formData.metaDescription}
//                     onChange={(e) =>
//                       setFormData({
//                         ...formData,
//                         metaDescription: e.target.value,
//                       })
//                     }
//                     className="form-control"
//                     rows={3}
//                   />
//                 </div>

//                 <div className="col-12 mb-3">
//                   <label>Short Description*</label>
//                   <JoditEditor
//                     ref={editor}
//                     config={config}
//                     value={shortDescription}
//                     onChange={(newContent) => setShortDescription(newContent)}
//                   />
//                 </div>

//                 <div className="col-12 mb-3">
//                   <label>Description*</label>
//                   <JoditEditor
//                     ref={editor}
//                     config={config}
//                     value={description}
//                     onChange={(newContent) => setDescription(newContent)}
//                   />
//                 </div>

//                 <div className="col-12">
//                   <button
//                     className="btn btn-primary w-100"
//                     style={{
//                       background: isFormValid ? "#05E2B5" : "#61ce70",
//                       border: "none",
//                       borderRadius: "24px",
//                       opacity: loader ? 0.6 : 1,
//                     }}
//                     onClick={isFormValid && !loader ? handleSubmit : null}
//                     disabled={!isFormValid || loader}
//                   >
//                     {loader ? "Saving..." : "Submit"}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div> 
//   );
// }

// export default AddBlog;


import React, { useState, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import { addBlogServ } from "../../services/blog.service";
import { useNavigate } from "react-router-dom";

/* ─── Scoped styles — same design language as BlogList / OrderList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@500&display=swap');

  .ab-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
    font-size: 15px;
  }

  /* ── Page header ── */
  .ab-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
    flex-wrap: wrap;
    gap: 12px;
  }
  .ab-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ab-back-btn {
    width: 40px;
    height: 40px;
    border-radius: 11px;
    border: 1px solid #f0eded;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #555;
    cursor: pointer;
    transition: all 0.18s;
    flex-shrink: 0;
  }
  .ab-back-btn:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }
  .ab-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1c0a0a;
    letter-spacing: -0.4px;
  }
  .ab-breadcrumb {
    font-size: 13px;
    color: #aaa;
    margin-top: 3px;
    font-weight: 500;
  }
  .ab-breadcrumb span { color: #a60808; }

  /* ── Card ── */
  .ab-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 28px 28px 32px;
    margin-bottom: 18px;
  }
  .ab-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.9px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .ab-section-title::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #f0eded;
  }

  /* ── Form grid ── */
  .ab-grid {
    display: grid;
    gap: 20px;
  }
  .ab-grid-2 { grid-template-columns: 1fr 1fr; }
  .ab-grid-3 { grid-template-columns: 1fr 1fr 1fr; }
  .ab-grid-1 { grid-template-columns: 1fr; }
  @media (max-width: 768px) {
    .ab-grid-2, .ab-grid-3 { grid-template-columns: 1fr; }
  }

  /* ── Field ── */
  .ab-field { display: flex; flex-direction: column; gap: 7px; }
  .ab-label {
    font-size: 13.5px;
    font-weight: 600;
    color: #333;
    letter-spacing: 0.1px;
  }
  .ab-label .ab-req { color: #a60808; margin-left: 2px; }
  .ab-label .ab-hint {
    font-size: 12px;
    color: #aaa;
    font-weight: 400;
    margin-left: 5px;
  }

  .ab-input,
  .ab-select,
  .ab-textarea {
    height: 46px;
    border-radius: 11px;
    border: 1px solid #ede9e9;
    padding: 0 16px;
    font-size: 15px;
    color: #333;
    background: #fafafa;
    outline: none;
    font-family: 'DM Sans', sans-serif;
    transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
    width: 100%;
  }
  .ab-input:focus,
  .ab-select:focus,
  .ab-textarea:focus {
    border-color: #f0c0b8;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(192,57,43,0.07);
  }
  .ab-input::placeholder,
  .ab-textarea::placeholder { color: #ccc; }
  .ab-input.error { border-color: #e74c3c; background: #fff8f8; }

  .ab-textarea {
    height: auto;
    padding: 14px 16px;
    resize: vertical;
    line-height: 1.6;
  }
  .ab-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23aaa' stroke-width='2.5'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    padding-right: 38px;
    cursor: pointer;
  }

  /* ── Banner upload ── */
  .ab-banner-wrap {
    border-radius: 12px;
    border: 2px dashed #ede9e9;
    overflow: hidden;
    background: #fafafa;
    transition: border-color 0.18s;
    cursor: pointer;
  }
  .ab-banner-wrap:hover { border-color: #f0c0b8; }
  .ab-banner-preview {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
  .ab-banner-placeholder {
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #ccc;
  }
  .ab-banner-placeholder i { font-size: 38px; color: #e8d0cd; }
  .ab-banner-placeholder p {
    font-size: 14px;
    color: #bbb;
    font-weight: 500;
    margin: 0;
  }
  .ab-file-input {
    margin-top: 10px;
    width: 100%;
    font-size: 14px;
    font-family: 'DM Sans', sans-serif;
    color: #555;
  }
  .ab-file-input::file-selector-button {
    height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    padding: 0 16px;
    font-size: 13.5px;
    font-weight: 600;
    color: #a60808;
    cursor: pointer;
    margin-right: 12px;
    font-family: 'DM Sans', sans-serif;
    transition: background 0.15s;
  }
  .ab-file-input::file-selector-button:hover { background: #fdf2f1; }

  /* ── Jodit editor override ── */
  .jodit-container {
    border-radius: 11px !important;
    border: 1px solid #ede9e9 !important;
    font-size: 15px !important;
    overflow: hidden;
    font-family: 'DM Sans', sans-serif !important;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .jodit-container:focus-within {
    border-color: #f0c0b8 !important;
    box-shadow: 0 0 0 3px rgba(192,57,43,0.07) !important;
  }
  .jodit-toolbar__box {
    border-bottom: 1px solid #f0eded !important;
    background: #fafafa !important;
  }
  .jodit-wysiwyg {
    font-family: 'DM Sans', sans-serif !important;
    font-size: 15px !important;
    color: #333 !important;
    min-height: 160px !important;
  }

  /* ── Submit section ── */
  .ab-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 4px;
  }
  .ab-cancel-btn {
    height: 48px;
    padding: 0 28px;
    border-radius: 12px;
    border: 1px solid #ede9e9;
    background: #fff;
    font-size: 15px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    transition: all 0.18s;
  }
  .ab-cancel-btn:hover { background: #f5f5f7; color: #333; }

  .ab-submit-btn {
    height: 48px;
    padding: 0 36px;
    border-radius: 12px;
    border: none;
    background: #a60808;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
    letter-spacing: 0.2px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: background 0.18s, transform 0.1s, opacity 0.18s;
  }
  .ab-submit-btn:hover:not(:disabled) { background: #a93226; transform: translateY(-1px); }
  .ab-submit-btn:active:not(:disabled) { transform: translateY(0); }
  .ab-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  /* ── Required fields note ── */
  .ab-required-note {
    font-size: 13px;
    color: #bbb;
    font-style: italic;
    margin-right: auto;
  }
  .ab-required-note span { color: #a60808; }
`;

function AddBlog() {
  const navigate = useNavigate();
  const editor = useRef(null);

  const config = {
    placeholder: "Start typing...",
    height: "280px",
    toolbarButtonSize: "middle",
  };

  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    image: "",
    imgPrev: "",
    title: "",
    seoTitle: "",
    metaKeyword: "",
    metaDescription: "",
    rank: "",
    tags: "",
    specialAppereance: "",
  });
  const [shortDescription, setShortDescription] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async () => {
    setLoader(true);
    try {
      let finalPayload = {
        ...formData,
        shortDescription,
        description,
      };
      let response = await addBlogServ(finalPayload);
      if (response?.data?.statusCode == "200") {
        toast.success("Blog saved successfully!");
        navigate("/blogs-list");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
    setLoader(false);
  };

  const isFormValid =
    formData.title &&
    formData.rank &&
    formData.tags.length > 0 &&
    shortDescription;

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Blog Management" selectedItem="Add Blog" />

      <div className="mainContainer">
        <TopNav />

        <div className="ab-page">

          {/* ── Page Header ── */}
          <div className="ab-header">
            <div className="ab-header-left">
              <button className="ab-back-btn" onClick={() => navigate("/blogs-list")}>
                <i className="ti ti-arrow-left" aria-hidden="true" />
              </button>
              <div>
                <div className="ab-page-title">Add New Blog</div>
                <div className="ab-breadcrumb">
                  Blog Management &rsaquo; <span>Add Blog</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Section 1: Banner ── */}
          <div className="ab-card">
            <div className="ab-section-title">
              <i className="ti ti-photo" aria-hidden="true" /> Banner Image
            </div>
            <div className="ab-field">
              <label className="ab-label">
                Blog Banner <span className="ab-req">*</span>
              </label>
              <div className="ab-banner-wrap">
                {formData.imgPrev ? (
                  <img
                    src={formData.imgPrev}
                    alt="Banner preview"
                    className="ab-banner-preview"
                  />
                ) : (
                  <div className="ab-banner-placeholder">
                    <i className="ti ti-cloud-upload" aria-hidden="true" />
                    <p>No image selected</p>
                  </div>
                )}
              </div>
              <input
                className="ab-file-input"
                type="file"
                accept="image/*"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    image: e.target.files[0],
                    imgPrev: URL.createObjectURL(e.target.files[0]),
                  })
                }
              />
            </div>
          </div>

          {/* ── Section 2: Basic Info ── */}
          <div className="ab-card">
            <div className="ab-section-title">
              <i className="ti ti-article" aria-hidden="true" /> Basic Information
            </div>

            <div className="ab-grid ab-grid-2" style={{ marginBottom: "20px" }}>
              <div className="ab-field">
                <label className="ab-label">
                  Title <span className="ab-req">*</span>
                </label>
                <input
                  className="ab-input"
                  placeholder="Enter blog title"
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                />
              </div>
              <div className="ab-field">
                <label className="ab-label">SEO Title</label>
                <input
                  className="ab-input"
                  placeholder="Enter SEO title"
                  value={formData.seoTitle}
                  onChange={(e) => setFormData({ ...formData, seoTitle: e.target.value })}
                />
              </div>
            </div>

            <div className="ab-grid ab-grid-3" style={{ marginBottom: "20px" }}>
              <div className="ab-field">
                <label className="ab-label">
                  Tags <span className="ab-req">*</span>
                  <span className="ab-hint">(comma separated)</span>
                </label>
                <input
                  className="ab-input"
                  placeholder="e.g. health, tips, lifestyle"
                  value={formData.tags}
                  onChange={(e) => setFormData({ ...formData, tags: e.target.value })}
                />
              </div>
              <div className="ab-field">
                <label className="ab-label">
                  Rank <span className="ab-req">*</span>
                </label>
                <input
                  className="ab-input"
                  type="number"
                  placeholder="e.g. 1"
                  value={formData.rank}
                  onChange={(e) => setFormData({ ...formData, rank: e.target.value })}
                />
              </div>
              <div className="ab-field">
                <label className="ab-label">Special Appearance</label>
                <select
                  className="ab-select"
                  value={formData.specialAppereance}
                  onChange={(e) =>
                    setFormData({ ...formData, specialAppereance: e.target.value })
                  }
                >
                  <option value="">Select</option>
                  <option value="Home">Home</option>
                </select>
              </div>
            </div>

            <div className="ab-field">
              <label className="ab-label">
                Meta Keywords
                <span className="ab-hint">(comma separated)</span>
              </label>
              <input
                className="ab-input"
                placeholder="e.g. blog, seo, keywords"
                value={formData.metaKeyword}
                onChange={(e) => setFormData({ ...formData, metaKeyword: e.target.value })}
              />
            </div>
          </div>

          {/* ── Section 3: SEO ── */}
          <div className="ab-card">
            <div className="ab-section-title">
              <i className="ti ti-search" aria-hidden="true" /> SEO & Description
            </div>

            <div className="ab-field" style={{ marginBottom: "20px" }}>
              <label className="ab-label">Meta Description</label>
              <textarea
                className="ab-textarea"
                rows={3}
                placeholder="Write a brief meta description for SEO..."
                value={formData.metaDescription}
                onChange={(e) =>
                  setFormData({ ...formData, metaDescription: e.target.value })
                }
              />
            </div>

            <div className="ab-field" style={{ marginBottom: "20px" }}>
              <label className="ab-label">
                Short Description <span className="ab-req">*</span>
              </label>
              <JoditEditor
                ref={editor}
                config={config}
                value={shortDescription}
                onChange={(newContent) => setShortDescription(newContent)}
              />
            </div>

            <div className="ab-field">
              <label className="ab-label">Full Description</label>
              <JoditEditor
                config={config}
                value={description}
                onChange={(newContent) => setDescription(newContent)}
              />
            </div>
          </div>

          {/* ── Actions ── */}
          <div className="ab-card" style={{ padding: "20px 28px" }}>
            <div className="ab-actions">
              <span className="ab-required-note">
                <span>*</span> Required fields
              </span>
              <button
                className="ab-cancel-btn"
                onClick={() => navigate("/blogs-list")}
              >
                Cancel
              </button>
              <button
                className="ab-submit-btn"
                onClick={isFormValid && !loader ? handleSubmit : undefined}
                disabled={!isFormValid || loader}
              >
                {loader ? (
                  <>
                    <i className="ti ti-loader-2" style={{ animation: "spin 1s linear infinite" }} aria-hidden="true" />
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="ti ti-device-floppy" aria-hidden="true" />
                    Publish Blog
                  </>
                )}
              </button>
            </div>
          </div>

          <style>{`
            @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          `}</style>

        </div>
      </div>
    </div>
  );
}

export default AddBlog;